import { WorkingHour } from "@/model/entities";
import { workingHoursService } from "@/service/workingHoursService";
import { useMutation, useQuery } from "@tanstack/react-query";

export function useWorkingHours(restaurantId: string) {
  const query = useQuery({
    queryKey: ["workingHours", restaurantId],
    queryFn: () => workingHoursService.fetchByRestaurantId(restaurantId),
    enabled: !!restaurantId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  const addWorkingHours = useMutation({
    mutationFn: (newWorkingHours: WorkingHour[]) =>
      workingHoursService.add(restaurantId, newWorkingHours),
    onSuccess: () => {
      query.refetch();
    },
  });

  return { ...query, addWorkingHours };
}
